import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './containers/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from 'redux/store'; // Assuming the modified store.js file is in the 'redux' directory
import './multilingual/index'
import FallBackLoader from './components/loader/FallbackLoader';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from 'components/dialogs/ErrorFallback';

const root = ReactDOM.createRoot(document.getElementById('root'));

const logError = (error, info) => {
  console.log(error, info);
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<FallBackLoader />}>
          <BrowserRouter>
            <ErrorBoundary
              FallbackComponent={ErrorFallback}
              onError={logError}
            >
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </Suspense>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
